module.exports = __webpack_public_path__ + "img/view_structure.02e5a253.svg";